import {DialogType} from '../../enum/dialog-type';
import {EventType} from '../../enum/event-type';
import {EmitService} from '../event/emit.service';
import {EmitterEvent} from '../event/prototype/emitter-event';
import {Injectable} from '@angular/core';

@Injectable()
export class DialogService extends EmitService {

  constructor() {
    super();
  }

  public show(dialogType: DialogType, data: any = null): void {
    switch (dialogType) {
      case DialogType.AGREEMENT:
        if (!data) {
          data = {
            'type': dialogType,
            'name': 'ご利用規約'
          };
        }

        this.dispatcher(new EmitterEvent(EventType.SHOW_AGREEMENT_DIALOG, data));
        break;
      case DialogType.QUIZ_ANSWER:
        if (!data) {
          data = {
            'type': dialogType,
            'name': ''
          };
        }

        this.dispatcher(new EmitterEvent(EventType.SHOW_QUIZ_DIALOG, data));
        break;
      default:
        break;
    }
  }

  public close(dialogType: DialogType, data: any = null): void {
    switch (dialogType) {
      case DialogType.AGREEMENT:
        this.dispatcher(new EmitterEvent(EventType.CLOSE_AGREEMENT_DIALOG, data));
        break;
      case DialogType.QUIZ_ANSWER:
        this.dispatcher(new EmitterEvent(EventType.CLOSE_QUIZ_DIALOG, data));
        break;
      default:
        break;
    }
  }
}



// WEBPACK FOOTER //
// /Users/mizunoe_jing/Documents/nice_day_current/bitbucket/starbright/src/app/service/dialog/dialog.service.ts